/* eslint-disable react/prop-types */
import React from 'react';

import { Carousel } from './Carousel';
import styles from './styles.module.scss';

export const PortraitTilesCarousel = (props) => (
    <div className={props.small ? '' : 'page-container'}>
        {props.subtitle && <p className={styles.subtitle}>{props.subtitle}</p>}
        {props.title && <h1 className={styles.title}>{props.title}</h1>}

        <Carousel items={props.portraitTiles} small={props.small} />
    </div>
);
